import {z} from 'zod'
import {validationRules} from './validationRules'

export const caseTeamSchema = z.object({
  caseId: validationRules.objectId,
  teams: validationRules.reactSelectID,
})

export type ICaseTeamForm = z.infer<typeof caseTeamSchema>
